import React from 'react';
import { CLASSNAME_PREFIX, TRANSLATION_CONTEXT } from '../componentConfig';
import './VerificationCounter.scss';

var VerificationCounter = function VerificationCounter(_ref) {
  var forcePeriodInMins = _ref.forcePeriodInMins,
      reminderCountdown = _ref.reminderCountdown,
      t = _ref.t;

  var counter = reminderCountdown <= Math.floor(forcePeriodInMins / (24 * 60));
  return reminderCountdown ? React.createElement(
    'div',
    { className: CLASSNAME_PREFIX + '-account-verification__counter' },
    t(TRANSLATION_CONTEXT)('accountVerification.youHave'),
    React.createElement(
      'span',
      { className: CLASSNAME_PREFIX + '-account-verification__counter' + (counter ? '--forced' : '--waiting') },
      reminderCountdown,
      ' ',
      t(TRANSLATION_CONTEXT)('accountVerification.days')
    )
  ) : null;
};

export default VerificationCounter;